import React from 'react';
import { useApplicationConfig } from '../../store';
import {
    Col,
    Row,
} from '@snsw/react-component-library';

interface DebugBoxSmallProps {
    withinDebugBox: boolean
}

/** Place within a larger debug box or a production component. **/
const DebugBoxSmall = (props: React.PropsWithChildren<DebugBoxSmallProps>) => {
    const appConfig = useApplicationConfig();
    return <>
        {
            appConfig.appConfig?.enableDebug && <Row>
                <Col
                    span={ 12 }
                    style={ props.withinDebugBox ? {} : {
                        backgroundColor: 'lightgrey',
                        borderStyle: 'dotted',
                        borderWidth: '2px',
                        marginTop: '50px',
                    } }
                >
                    {
                        !props.withinDebugBox &&
                            <p><i>This panel shows because the 'enableDebug' flag is switched on in 'appConfig'.</i></p>
                    }
                    {
                        props.children
                    }
                </Col>
            </Row>
        }
    </>;
};

export default DebugBoxSmall;
